import { createTheme } from '@mantine/core';

export const theme = createTheme({
  colors: {
    practistBlue: [
      '#eaefff',
      '#d3daff',
      '#a5b2f7',
      '#7487f0',
      '#566ceb',
      '#304be7',
      '#2140e6',
      '#1232cd',
      '#082cb8',
      '#0025a3',
    ],
  },
});
